if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"idun","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(60[34]|(22|8|97)2|269|98)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}